var map = {
	"./EN/als": 45,
	"./EN/als.ts": 45,
	"./EN/datum": 46,
	"./EN/datum.ts": 46,
	"./EN/defaultMessages": 19,
	"./EN/defaultMessages.ts": 19,
	"./EN/joinedUp": 47,
	"./EN/joinedUp.ts": 47,
	"./EN/staffline": 48,
	"./EN/staffline.ts": 48
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;